import { createAction } from 'redux-actions'
import { actionCreators as api } from 'reduxBits/api'

export const HERO_AD_DISPLAYED_COOKIE_NAME = 'hero'
export const SET_HERO_AD_DISPLAYED_STATUS = 'Set Hero ad placement display status'

export const SET_INVENTORY_DATA = 'Set inventory Data'

const setInventoryData = createAction(SET_INVENTORY_DATA)
export const setHeroAdDisplayedStatus = createAction(SET_HERO_AD_DISPLAYED_STATUS)

export const fetchInventoryData = (path = 'index', adId = '') => async (dispatch) => {
  const response = await dispatch(api.fetch(`marketing/v1/inventory?view=${path}&ad_id=${adId}`))

  if (response.ok) {
    const payload = response.textOrJson._raw
    dispatch(setInventoryData(payload))
  }
}

export const actionCreators = {
  fetchInventoryData,
  setHeroAdDisplayedStatus,
}
